/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SummaryConversioneDTO
 */
export interface SummaryConversioneDTO {
    /**
     * 
     * @type {number}
     * @memberof SummaryConversioneDTO
     */
    indiceDiConversione?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryConversioneDTO
     */
    indiceDiConversioneMedio?: number | null;
}

/**
 * Check if a given object implements the SummaryConversioneDTO interface.
 */
export function instanceOfSummaryConversioneDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SummaryConversioneDTOFromJSON(json: any): SummaryConversioneDTO {
    return SummaryConversioneDTOFromJSONTyped(json, false);
}

export function SummaryConversioneDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryConversioneDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'indiceDiConversione': !exists(json, 'indiceDiConversione') ? undefined : json['indiceDiConversione'],
        'indiceDiConversioneMedio': !exists(json, 'indiceDiConversioneMedio') ? undefined : json['indiceDiConversioneMedio'],
    };
}

export function SummaryConversioneDTOToJSON(value?: SummaryConversioneDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'indiceDiConversione': value.indiceDiConversione,
        'indiceDiConversioneMedio': value.indiceDiConversioneMedio,
    };
}

